<div class="b-t b-col-42 m-t-7">
    <!-- Accordion item / product details -->
    <expandable2 [expandableTitle]="'Product Details' | translate"
                 [expandableId]="detailsZippyId"
                 class="block"
                 [scrollNavTarget]="'Description' | translate"
                 (scrollNavScrollTo)="zippyService.open(detailsZippyId)">
        <!-- description -->
        @if (parent.getAttr('description')) {
        <read-more class="p1 col-1"
                   [text]="parent.getAttr('description')"
                   [limit]="[150,150,250,250][client.sizeId]"
                   [readLess]="true"
                   [inline]="true"
                   [hideDots]="true">
        </read-more>
        }
    </expandable2>

    <!-- Accordion item / info and care -->
    @if (product.getAttr('care')) {
    <expandable2 [expandableTitle]="'Info & Care' | translate"
                 [expandableId]="['pdp_accordion', 'care']">
        <div [innerHtml]="product.getAttr('care')"></div>
    </expandable2>
    }

    @if(!product.isSoldOut) {
    <!-- Accordion item / how it fits -->
    @if (product.getAttr('how_it_fits')) {
    <expandable2 [expandableTitle]="'How it Fits' | translate"
                 [expandableId]="['pdp_accordion', 'how_it_fits']">
        <div class="text"
             [innerHtml]="product.getAttr('how_it_fits')"></div>
    </expandable2>
    }

    @if(product.getAttr('delivery_returns_note') || content.deliveryCopy?.length) {
    <!-- Accordion item / delivery and returns -->
    <expandable2 [expandableTitle]="'Delivery & Returns' | translate"
                 [expandableId]="['pdp_accordion', 'delivery']"
                 *ifNotTradeStore>
        @switch (!!product.getAttr('delivery_returns_note')) {
        @case (true) {
        <div [innerHtml]="product.getAttr('delivery_returns_note')"></div>
        }
        @default {
        <div *iCms="'deliveryCopy' of content; content: 'html'">
        </div>
        }
        }
    </expandable2>
    }
    }

    <!-- Reviews -->
    @if (showReviews) {
    @if (showReviews) {
    <product-reviews-summary class="block b-b b-col-42"
                             [source]="parent">
        <p class="o1 m-r p-t-5 p-b-5 p-t-4-m p-t-4-s p-b-4-m p-b-4-s">
            {{'Reviews' | translate}}
        </p>
        <i class="icon-chevron fs-8 fs-9-m fs-9-s col-43 pos-absolute right-0 inline-flex"></i>
    </product-reviews-summary>
    }
    }

</div>